import { render, staticRenderFns } from "./currency-exchange.vue?vue&type=template&id=d2b8d5b6&scoped=true&"
import script from "./currency-exchange.vue?vue&type=script&lang=js&"
export * from "./currency-exchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b8d5b6",
  null
  
)

export default component.exports